import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ZestCommonModule } from '../common/common.module';
import { MaterializeModule } from 'angular2-materialize';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { FileUploadPickerComponent } from './file-upload-picker/file-upload-picker.component';
import { FileUploadProgressComponent } from './file-upload-progress/file-upload-progress.component';
import { FileUploadPickerV2Component } from './file-upload-picker-v2/file-upload-picker-v2.component';
import { FileUploadProgressV2Component } from './file-upload-progress-v2/file-upload-progress-v2.component';
import { CameraFileUploaderComponent } from './camera-file-uploader/camera-file-uploader.component';

@NgModule({
  declarations: [
    FileUploadPickerComponent,
    FileUploadProgressComponent,
    FileUploadPickerV2Component,
    FileUploadProgressV2Component,
    CameraFileUploaderComponent
  ],
  imports: [
    CommonModule,
    ZestCommonModule,
    MaterializeModule,
    PdfViewerModule,
    FormsModule
  ],
  exports: [
    FileUploadPickerComponent,
    FileUploadProgressComponent,
    FileUploadPickerV2Component,
    FileUploadProgressV2Component,
    CameraFileUploaderComponent
  ]
})
export class FilesModule { }
